<template>
  <v-app id="base">
    <AppBar v-if="!hideAppBar" :title="appTitle" />

    <Drawer v-if="!hideDrawer" />

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import colors from "vuetify/lib/util/colors";

import Drawer from "./components/Drawer";
import AppBar from "./components/AppBar";

export default {
  name: "App",

  components: {
    Drawer,
    AppBar
  },

  data: () => ({
    currentRouteName: "",
    routeConfigs: {
      "pomodoro-active-session": {
        "title": "Active Session",
        "primaryColor": colors.red.darken1
      },
      "pomodoro-review": {
        "title": "Review",
        "primaryColor": colors.red.darken1
      },
      "training-workout": {
        "title": "Workout",
        "primaryColor": colors.blue.darken2
      },
      "training-history": {
        "title": "History",
        "primaryColor": colors.blue.darken2
      },
      "training-weight": {
        "title": "Weight",
        "primaryColor": colors.blue.darken2
      },
      "training-progress-pictures": {
        "title": "Progress Pictures",
        "primaryColor": colors.blue.darken2
      },
      "mood-diary": {
        "title": "Mood Diary",
        "primaryColor": colors.green
      },
      "mood-reports": {
        "title": "Mood Reports",
        "primaryColor": colors.green
      },
      "sign-in": {
        "title": "Login",
        "primaryColor": "#ee44aa",
        "hideDrawer": true,
        "hideAppBar": true
      }
    }
  }),

  mounted: function () {
    this.currentRouteName = this.$route.name;
    this.updatePrimaryColor();
  },

  watch: {
    $route(to) {
      this.currentRouteName = to.name;
      this.updatePrimaryColor();
    }
  },

  computed: {
    currentRouteConfig: function () {
      return this.routeConfigs[this.currentRouteName] || null;
    },
    appTitle: function () {
      if (!this.currentRouteConfig) {
        return "Tracker";
      }
      return this.currentRouteConfig.title;
    },
    hideDrawer: function () {
      if (!this.currentRouteConfig || this.currentRouteConfig.hideDrawer) {
        return true;
      }
      return false;
    },
    hideAppBar: function () {
      if (!this.currentRouteConfig || this.currentRouteConfig.hideAppBar) {
        return true;
      }
      return false;
    }
  },

  methods: {
    updatePrimaryColor: function () {
      let color = "#ee44aa";
      if (this.currentRouteConfig) {
        color = this.currentRouteConfig.primaryColor;
      }
      this.$vuetify.theme.themes.light.primary = color;
    }
  }
};
</script>

<style lang="scss" scoped></style>
